<template>
  <div class="body-width" >
    <div class="div-row div-pad-top news-Medium-24" >
      海军作战演练系统
    </div>
    <div class="div-row">
      <p class="indentation">V.Dragon-NavalDrill 5000型海军作战演练系统可进行大规模海军作战、指挥演练，主要由导演台、作战指挥单元、舰船作战单元、潜艇作战单元、直升机作战单元等组成。系统可实现不同海况、天气条件下的战场环境仿真，可进行战场指挥演练、作战方案预演、对抗演练、武器装备操作训练、海陆空协战等，满足各作战单元的技能、流程、业务等各类训练需求，还可用于海上综合行政执法、舰艇编队巡航训练等。</p>
    </div>
    <div>
      <div class="div_float_left">
        <div align="left">
          <ul>
            <li><span>海陆空作战环境真实感呈现</span></li>
            <li><span>多样化的作战训练场景</span></li>
            <li><span>丰富的模型资源</span></li>
            <li><span>指挥导演灵活控制</span></li>
            <li><span>指挥导演灵活控制</span></li>
          </ul>
        </div>
        <div class="div_img">
          <div>
            <img src="../../../../assets/images/productcenter/hsyl/hjzz/1.png">
          </div>
          <div class="pad_top30">
            <img src="../../../../assets/images/productcenter/hsyl/hjzz/3.png">
          </div>
        </div>
      </div>
      <div class="div_float_right pad_right53">
        <div align="left" >
          <ul>
            <li><span>多兵种协同对抗演练</span></li>
            <li><span>作战方案预演 </span></li>
            <li><span>武器操作训练</span></li>
            <li><span>海警海上综合执法演练</span></li>
            <li><span>舰队联合机动编队训练</span></li>
          </ul>
        </div>
        <div class="div_img">
          <div>
            <img src="../../../../assets/images/productcenter/hsyl/hjzz/2.png">
          </div>
          <div class="pad_top30">
            <img src="../../../../assets/images/productcenter/hsyl/hjzz/4.png">
          </div>
        </div>
      </div>
    </div>
    <div>
      <img style="padding: 30px 15px 0px 0px "  src="../../../../assets/images/productcenter/hsyl/hjzz/5.png">
    </div>

  </div>
</template>

<script>
  export default {
    name: "hjzzylxt"
  }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .div_float_left{
    float: left;
  }
  .div_float_right{
    float: right;
  /*  padding-right: 300px;*/
  }
  li{
    color: #2E79BE;

  }
  li span{
    color: #666666;
  }
  .div_img{
    padding-top: 10px;
    padding-left: 35px;
  }
  .pad_top30{
    padding-top: 30px;
  }
  .pad_right53{
    padding-right: 53px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hsylxlcp/hjzzylxt.vue